import * as React from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'
import InputAdornment from '@mui/material/InputAdornment'
import CircularProgress from '@mui/material/CircularProgress'

type InformationFormPropTypes = {
  values: {
    displayName: string
    websiteUrl: string
    description: string
    ccEmail: string
  }
  errors: {
    displayName: string
    ccEmail?: string
  }
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onDecidingRoleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onReceiveRequestForProposalsChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
  onCcEmailBlur: (event: React.FocusEvent<HTMLInputElement>) => void
  isCompanyLoading?: boolean
}

const InformationForm: React.FC<InformationFormPropTypes> = ({
  values,
  errors,
  onChange,
  onBlur,
  onCcEmailBlur,
  isCompanyLoading = false
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '650px', mt: 2, pl: 2, pr: 2 }}>
      <TextField
        id="display-name"
        label={t('company-display-name')}
        variant="filled"
        required
        sx={{ width: '100%', maxWidth: '462px' }}
        value={values.displayName}
        onChange={onChange}
        name="displayName"
        onBlur={onBlur}
        helperText={errors.displayName}
        error={errors.displayName !== ''}
        fullWidth
      />
      <TextField
        id="website"
        label={t('website-address')}
        variant="filled"
        sx={{ width: '100%', maxWidth: '355px' }}
        margin="normal"
        value={values.websiteUrl}
        onChange={onChange}
        name="websiteUrl"
        fullWidth
        InputProps={{
          endAdornment: isCompanyLoading && (
            <InputAdornment position="end">
              <CircularProgress size={24} />
            </InputAdornment>
          )
        }}
      />
      <TextField
        variant="filled"
        id="description"
        label={t('free-description-text')}
        multiline
        minRows={4}
        maxRows={Infinity}
        margin="dense"
        fullWidth
        value={values.description}
        onChange={onChange}
        name="description"
        inputProps={{
          maxLength: 1000
        }}
        helperText={`${values.description.length} / 1000`}
      />
      <TextField
        id="cc-email"
        type="email"
        label={t('cc-email')}
        variant="filled"
        sx={{ width: '100%', maxWidth: '462px' }}
        margin="normal"
        value={values.ccEmail}
        onChange={onChange}
        name="ccEmail"
        onBlur={onCcEmailBlur}
        error={Boolean(errors.ccEmail)}
        helperText={errors.ccEmail ? errors.ccEmail : t('cc-email-helper-text')}
        fullWidth
      />
    </Box>
  )
}

export default InformationForm
